import { YhBox } from "@/erp_subpackage/components/YhBox";
import { importPropsConfig } from "@/erp_subpackage/utils/importFile";
import { MyContext } from "@/store/myContext";
import { getUserBtn } from "@/utils/dataStorage";
import { Button, message, Modal, Spin, Upload } from "antd";
import React, { useContext } from "react";
import { useTranslation } from 'react-i18next';
import { useGoodsModel } from "../goodsModel";
import { DataTable } from "./DataTable";

export const DataBox = () => {
    const { t } = useTranslation();
    const { selectedRowKeys, shopId, shopName, searchParam, exportGoods, sync, downloadTpl, loadData, uploading, setUploading } = useGoodsModel();
    const { state, dispatch, detailsPage } = useContext(MyContext);
    //新增 查看 编辑
    const goPageNav = (mode) => {
        let tabName = {
            add: t(`base.view.DataBox.商品新增`),
            edit: t(`base.view.DataBox.商品编辑`),
            look: t(`base.view.DataBox.商品查看`),
        }
        let modeKey = "baseGoods/" + mode;

        //动态传入要删除的nav key
        const handleDispatch = (obj = {}) => {
            dispatch({
                ...obj,
                type: "changeTabs",
                name: tabName[mode],
                activeMenu: modeKey,
                content: detailsPage.BaseGoodsDetails({
                    modeKey,
                    mode,
                    dispatch,
                    rowId: selectedRowKeys[0]
                }),
            })
        }

        if (mode === "edit") {
            const findNav = state.panes.find(item => item.key === modeKey);
            if (findNav) {
                Modal.confirm({
                    title: `${t(`base.view.DataBox.温馨提醒`)}！`,
                    content: t(`base.view.DataBox.您还有商品详情未保存，是否跳转`),
                    okText: t(`base.view.DataBox.跳转未保存页`),
                    cancelText: t(`base.view.DataBox.打开新页签`),
                    onOk: () => {
                        handleDispatch()
                    },
                    //打开新页签重新生成
                    onCancel: () => {
                        handleDispatch({ deleteKey: modeKey })
                    }
                });
                return;
            }
            handleDispatch()
        }
        else if (mode === "add") {
            handleDispatch()
        }
    }

    const uploadCallback = (params) => {
        setUploading({ spinning: false })
        params && loadData()
    }

    //资源权限
    const butResourceApply = (str) => {
        let resource = getUserBtn("baseGoods") || {}
        resource = resource.children || []
        return resource.find((item) => item.path === str) ? true : false
    }
    const action = <>
        <Button
            className="btn-item"
            shape="round"
            onClick={() => {
                goPageNav("add")
            }}
        > {t(`base.view.DataBox.新增`)}</Button>
        <Button
            className="btn-item"
            shape="round"
            onClick={() => {
                if (selectedRowKeys.length !== 1) {
                    message.warning(`${t(`base.view.DataBox.请选择单条数据进行编辑，点击鼠标右键可一键选中哦`)}！`)
                    return;
                }
                goPageNav("edit")
            }}
            disabled={searchParam.shopId === "" || (searchParam.shopId && searchParam.shopId !== shopId)}
        > {t(`base.view.DataBox.编辑`)}</Button>
        <Upload showUploadList={false} {...importPropsConfig(`/ci-storage/base/material/import`, uploadCallback, { shopId, shopName }, () => setUploading({ spinning: true, tip: `${t(`base.view.DataBox.加速上传中`)}...` }))} >
            <Button
                className="btn-item"
                shape="round"
                disabled={searchParam.shopId === "" || (searchParam.shopId && searchParam.shopId !== shopId)}
            > {t(`base.view.DataBox.导入`)}</Button>
        </Upload>
        <Button
            className="btn-item"
            shape="round"
            onClick={() => exportGoods()}
        > {t(`base.view.DataBox.导出`)}</Button>
        <Button
            className="btn-item"
            shape="round"
            onClick={() => downloadTpl()}
            disabled={searchParam.shopId === "" || (searchParam.shopId && searchParam.shopId !== shopId)}
        > {t(`base.view.DataBox.下载模板`)}</Button>
        <Upload showUploadList={false} {...importPropsConfig(`/ci-storage/base/material/importImg`, uploadCallback, { shopId, shopName }, () => setUploading({ spinning: true, tip: `${t(`base.view.DataBox.加速上传中`)}...` }), "zip")}>
            <Button className="btn-item" shape="round" disabled={searchParam.shopId === "" || (searchParam.shopId && searchParam.shopId !== shopId)}> {t(`base.view.DataBox.导入图片`)}</Button>
        </Upload>
    </>;

    return (
        <Spin {...uploading}>
            <YhBox title={t(`base.view.DataBox.商品列表`)} action={action}>
                <DataTable />
            </YhBox>
        </Spin>
    )
}

